import { type IDataLocationForm } from '../interfaces';

export const defaultDataLocation: IDataLocationForm = {
  id: 0,
  name: '',
  description: '',
  isEnabled: true,
  sortOrder: 0,
  connectionId: '',
};
